import React from "react";
// Spinner Component

import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

const Spinner = ({
  size = "30px",
  color = "primary",
}: {
  size?: string;
  color?:
    | "primary"
    | "inherit"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning";
}) => {
  return (
    <Stack direction={"row"} justifyContent={"center"} alignItems="center">
      <CircularProgress size={size} color={color} />
    </Stack>
  );
};

export default Spinner;
